import { render } from "./Navbar.vue?vue&type=template&id=41458b80"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Navbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41458b80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41458b80', __exports__)) {
    api.reload('41458b80', __exports__)
  }
  
  module.hot.accept("./Navbar.vue?vue&type=template&id=41458b80", () => {
    api.rerender('41458b80', render)
  })

}


export default __exports__